var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnitDefensiveSpecialists(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 512 512",
    id: "svg169",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier",
    transform: "matrix(1,0,0,-1,0,509.868)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 77.85,11.848 9.535,70.648 -69.418,-11.174 41.508,56.07 -11.127,322.715 c -11.712,13.235 -20.716,28.85 -25.823,47.914 74.198,-55.834 152.88,-71.602 223.606,-101.383 l -35.913,-35.914 c -53.122,25.232 -105.774,42.49 -142.547,71.347 l 9.674,-280.54 8.06,10.888 2.2,4.47 h 71.304 L 358.723,394.03 c 15.618,-13.627 29.605,-28.41 42.66,-44.645 L 171.506,155.605 V 84.226 l -11.86,-9.165 273.594,-10.66 c -29.99,36.36 -46.84,89.07 -71.39,142.416 l 36.558,36.56 c 29.22,-70.24 45.014,-148.09 100.262,-221.507 -18.54,4.97 -33.69,13.015 -46.604,23.603 l -0.02,-0.506 -315.437,12.29 -58.76,-45.41 z m 24.613,42.638 50.355,38.916 v 54.795 H 99.236 l -0.607,-0.146 -38.357,-50.988 49,7.89 -6.81,-50.466 z m 248.103,167.48 c -8.162,13.275 -17.044,25.835 -26.586,37.727 l 30.727,25.903 c 11.16,-8.75 22.568,-17.176 34.06,-25.432 l -38.2,-38.2 z m 100.006,89.74 C 414.826,368.52 375.184,412.43 315.88,447.67 c 59.143,20.683 118.488,37.302 178.8,43.98 -8.706,-60.66 -23.977,-120.562 -44.108,-179.94 z m -184.08,5.774 c -13.42,10.98 -27.58,21.186 -42.414,30.674 l 37.47,37.47 c 8.748,-14.57 18.62,-27.954 29.327,-40.43 z",
    id: "path166"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnitDefensiveSpecialists);
export default __webpack_public_path__ + "static/media/unit-defensive-specialists.9233c5fedddd3d2fa4cc9b94dc04886d.svg";
export { ForwardRef as ReactComponent };